import { render, staticRenderFns } from "./newsInformation.vue?vue&type=template&id=b042779a&scoped=true"
import script from "./newsInformation.vue?vue&type=script&lang=js"
export * from "./newsInformation.vue?vue&type=script&lang=js"
import style0 from "./newsInformation.vue?vue&type=style&index=0&id=b042779a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b042779a",
  null
  
)

export default component.exports